module.exports = __webpack_public_path__ + "static/media/save-template-popup.b0b847f2.png";